/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Version } from './version';
import { ValidValueRange } from './validValueRange';


export interface DeviceTypeParameterConfig { 
    defaultValue?: string;
    minFirmwareVersion?: Version;
    minPcbTypeId?: string;
    note?: string;
    parameterId: string;
    parsedList?: Array<string>;
    parsedMax?: string;
    parsedMin?: string;
    userAccess: DeviceTypeParameterConfig.UserAccessEnum;
    validValueRange?: ValidValueRange;
}
export namespace DeviceTypeParameterConfig {
    export const UserAccessEnum = {
        None: 'NONE',
        ReadLocal: 'READ_LOCAL',
        ReadRemote: 'READ_REMOTE',
        WriteLocal: 'WRITE_LOCAL',
        WriteRemote: 'WRITE_REMOTE'
    } as const;
    export type UserAccessEnum = typeof UserAccessEnum[keyof typeof UserAccessEnum];
}


export type UserAccessEnum = typeof DeviceTypeParameterConfig.UserAccessEnum[keyof typeof DeviceTypeParameterConfig.UserAccessEnum];
